module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Chef-3b54209f49e07918faea606a7f7a8df1.svg";